import { Component, OnInit,ViewChild } from '@angular/core';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-aggregation-reports',
  templateUrl: './aggregation-reports.component.html',
  styleUrls: ['./aggregation-reports.component.css']
})
export class AggregationReportsComponent implements OnInit {
  fieldDropDownList : object = {AssesmentList:{},StateList:[],DistrictList:[]};
  userdetails = {};
  filterDropDownList : object = {AssesmentYearList:[], GroupList:[], StateList:[], IndicatorList:[], ThemeList:[],Statedropdown:[],DistrictList:[]};
  filterDropDownLists : object = {AssesmentYearList:[], GroupList:[], StateList:[], IndicatorList:[], ThemeList:[],Statedropdown:[],DistrictList:[]};
  formInputfilter : object = {'ay':"",'lu':""};
  aggregatedScore :any;
  quaterlyScore : any;
  halfearlyScore :any;
  quaterlyflag: boolean;
  stateArrayList: any[];
  statelists: any[];
  selectedstate : any;
  selectedistrict :any;
  filterdistrict: any;
  showdistdrop: boolean;
  districtentityList: any[];
  annuallyScore:any;
  selectdistrict: any;
  quaterlyScoreflag: boolean;
  halfearlyScoreflag: boolean;
  showtabledata: boolean;
  activeSpinner: boolean;
  selectedUUID: any;
  aggregateddata: any = [];
  quaterlyScoreflag1: boolean;
  quaterlyScoreflag2: boolean;
  quaterlyScoreflag3: boolean;
  halfearlyScoreflag1: boolean;
  yearDropDownList: any;

  constructor(public tableconstants : TableConstantsModule,
    private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule,
    private utils : UtilsModule,
    private logsrv : AuthloginService,
    private toastr : ToastrService,) { }

  ngOnInit() {
    this.initializeOnStateLoad(null);
  }
  initializeOnStateLoad(call){
    console.log(this.quaterlyScore)
    this.userdetails = this.logsrv.checkloginstatus();
    this.getAssesmentYear();
    this.getstateslist();
    this.formInputfilter['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];

  }
  getAssesmentYear(){
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });  }
  getstateslist(){
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
            this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);

          });
        })
      }
    })
  
  }
  typechanged(){
    if(this.aggregatedScore == 'quaterlywise'){
      this.quaterlyflag = true;
    }
  }
  groupListForMultiDropDown(data:any,issort:boolean): any{
    let result = [];
      for(let i = 0; i < data.length; i++){
        if(!data[i]) continue;
        let item = {};
        item['item_id'] = data[i]['uuid'];//id++;
        item['item_text'] = data[i]['name'];
        result.push(item);
      }
      if(issort)
       result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);

    return result;
  }
  showdistrictdropdown(stateuuid){
    this.filterdistrict = stateuuid;
    if(stateuuid){
      this.showdistdrop = true;
    } else{
      this.showdistdrop = false;
    }
    if(this.showdistdrop){
      this.getDistrictList();
    }
  }
  getDistrictList(){
    this.districtentityList = [];
    this.selectdistrict = undefined;
    let postdata = {
      'pType':this.constants.LOCATION_CONSTANT['STATE'],
      'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    }
    this.submitdataSerivce.getLocationListforUser(postdata).subscribe(data =>{
      if(Array.isArray(data)){
        this.districtentityList = data;
      }
     
  },function(err){
      this.activespineer = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  scoredropdownchange(){
    if(this.quaterlyScore == 'quaterlyscore'){
      this.quaterlyScoreflag = true;
    } else if(this.quaterlyScore == 'quaterlyscore1'){
       this.quaterlyScoreflag1 = true;     
    } else if(this.quaterlyScore == 'quaterlyscore2'){
      this.quaterlyScoreflag2 = true;
    } else if(this.quaterlyScore == 'quaterlyscore3'){
      this.quaterlyScoreflag3 = true;
    }
  }
  halfearlydropdownchange(){
   if(this.halfearlyScore == 'halfearlyscore'){
     this.halfearlyScoreflag = true;
   } else if(this.halfearlyScore == 'halfearlyscore1'){
     this.halfearlyScoreflag1 = true;
   }
  }
  getdistuuid(districtlist){
    this.selectedUUID = districtlist
  }
  getquataggdata(){
    this.showtabledata = true;
    this.activeSpinner = true;
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['component'] = this.constants.COMPONENT['AGGREGATED_DATA'];
    postdata['view'] = this.constants['VIEWS']['admin']
    postdata['cType']  = this.constants.LOCATION_CONSTANT['DISTRICT'];
    postdata['userType'] = this.userdetails['roles'][0]
    postdata['lu'] = this.selectedUUID;
    if(this.quaterlyScore == 'quaterlyscore'){
      postdata['dataFor'] = this.constants.DATA_QUATERLY_OBJ['QUATERLY_DATA']
    }
    if(this.quaterlyScore == 'quaterlyscore1'){
      postdata['dataFor'] = this.constants.DATA_QUATERLY_OBJ['QUATERLY_DATA1']
    }
    if(this.quaterlyScore == 'quaterlyscore2'){
      postdata['dataFor'] = this.constants.DATA_QUATERLY_OBJ['QUATERLY_DATA2']
    }
    if(this.quaterlyScore == 'quaterlyscore3'){
      postdata['dataFor'] = this.constants.DATA_QUATERLY_OBJ['QUATERLY_DATA3']
    }
    postdata['aggrBasedOn'] = "QUARTERLY";
    this.submitdataSerivce.getaggregatedData(postdata).subscribe(data =>{
      this.activeSpinner = false;
      this.aggregateddata = data;
    })
  }
  gethalfaggdata(){
    this.showtabledata = true
    this.activeSpinner = true;
    let postdata = {};
    postdata = this.formatsenddata();
    if(this.halfearlyScore == 'halfearlyscore'){
     postdata['dataFor'] = "H1";
  }
  if(this.halfearlyScore == 'halfearlyscore1'){
    postdata['dataFor'] = "H2"
  }
  postdata['aggrBasedOn'] = "HALF_YEARLY";
  this.submitdataSerivce.getaggregatedData(postdata).subscribe(data =>{
    this.activeSpinner = false;
    this.aggregateddata = data;
  })
}
getannualaggdata(){
  this.showtabledata = true
  this.activeSpinner = true;
  let postdata = {};
  postdata = this.formatsenddata();
postdata['aggrBasedOn'] = "ANNUALY";
this.submitdataSerivce.getaggregatedData(postdata).subscribe(data =>{
  this.activeSpinner = false;
  this.aggregateddata = data;
})
}
  formatsenddata(){
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['component'] = this.constants.COMPONENT['AGGREGATED_DATA'];
    postdata['view'] = this.constants['VIEWS']['admin']
    postdata['cType']  = this.constants.LOCATION_CONSTANT['DISTRICT'];
    postdata['userType'] = this.userdetails['roles'][0]
    postdata['lu'] = this.selectedUUID;
    return postdata;
  }

}
